import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Panel, ListGroup, ListGroupItem, Label, Alert } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';
import { withNamespaces, Trans } from 'react-i18next';
import utils from '../../../common/services/utils';
import { Checkbox } from 'react-icheck';
import 'icheck/skins/minimal/grey.css';
import ReduxBlockUi from 'react-block-ui/redux';

class WorkshopSessions extends Component {
	constructor(props) {
		super(props);

		this.handleChangeSelection = this.handleChangeSelection.bind(this);
		this.handleConfirmSelection = this.handleConfirmSelection.bind(this);

		this.state = {
			selectedWorkshopSessions: []
		};
	}

	componentDidMount() {
		// initialize selection if sessions were pre-selected on the public page before login/register
		if (this.props.bookingOptions.selectedWorkshopSessionIds.length > 0 && this.props.workshopSessions.length > 0) {
			this.initializeDefaultSelectedSessions(this.props.bookingOptions.selectedWorkshopSessionIds, this.props.workshopSessions);
		}
	}

	componentWillReceiveProps(nextProps) {
		// initialize selection if sessions were pre-selected on the public page before login/register
		if (this.props.bookingOptions.selectedWorkshopSessionIds.length > 0 && this.props.workshopSessions.length === 0 && nextProps.workshopSessions.length > 0) {
			this.initializeDefaultSelectedSessions(this.props.bookingOptions.selectedWorkshopSessionIds, nextProps.workshopSessions);
		}
	}

	initializeDefaultSelectedSessions(selectedWorkshopSessionIds, allWorkshopSessions) {
		const selectedSessions = selectedWorkshopSessionIds.map(id => allWorkshopSessions.find(x => x.id === id)).filter(x => !!x);
		this.handleChangeSelection(selectedSessions, true);
	}

	handleChangeSelection(sessions, checked) {
		let currentSelection = this.state.selectedWorkshopSessions;
		sessions.forEach(session => {
			const selected = currentSelection.some(x => x.id === session.id);
			if (checked && !selected) {
				currentSelection.push(session);

				if (session.type === 'FullDay') {
					// remove selected half day sessions on same date
					currentSelection = currentSelection.filter(x => x.type === 'FullDay' || !moment(x.start).startOf('day').isSame(moment(session.start).startOf('day')));
				} else {
					// remove selected full day session on same date
					currentSelection = currentSelection.filter(x => x.type !== 'FullDay' || !moment(x.start).startOf('day').isSame(moment(session.start).startOf('day')));
				}
			}
			if (!checked && selected) {
				currentSelection = currentSelection.filter(x => x.id !== session.id);
			}
		});

		this.setState({ selectedWorkshopSessions: currentSelection });
	}

	handleConfirmSelection() {
		this.props.onSelectSessions(this.state.selectedWorkshopSessions.map(x => x.id));
	}

	renderWeek(week) {
		const { workshopSessions, currentUser, t } = this.props;

		const sessionsInWeek = workshopSessions.filter(x => x.weekId === week.id);

		const renderSelectAllCheckbox = sessionType => {
			const availableSessions = sessionsInWeek.filter(x => x.type === sessionType && x.availability !== 'No' && (x.upcoming || currentUser.userImpersonation));
			const allSessionsSelected = availableSessions.every(x => this.state.selectedWorkshopSessions.some(s => s.id === x.id));
			return availableSessions.length > 0 ? <span style={{ marginLeft: '15px' }}> <Checkbox checkboxClass='icheckbox_minimal-grey bg' increaseArea='20%' label={t(`FO_Booking_Workshop_All${sessionType}`)}
				checked={allSessionsSelected} onChange={(e, checked) => this.handleChangeSelection(availableSessions, checked)} /></span> : null;
		};

		return <div key={week.id} style={{ marginBottom: '15px' }}>
			<h3>{week.name} <span className='text-muted' style={{ fontSize: '16px' }}>{`(${moment(week.startDate).format('ll')} - ${moment(week.endDate).format('ll')})`}</span></h3>
			{t('FO_Booking_Workshop_SelectAll')}{renderSelectAllCheckbox('FullDay')}{renderSelectAllCheckbox('Morning')}{renderSelectAllCheckbox('Afternoon')}
			{this.renderSessionsInWeek(week, sessionsInWeek)}
		</div>
	}

	renderSessionsInWeek(week, sessions) {
		const { currentUser, enableUserTimeZone, center, limitToShowLeftWorkshopSpots, t } = this.props;

		sessions.sort((a, b) => moment(a.start) - moment(b.start)).forEach(x => {
			const sessionStart = (enableUserTimeZone ? utils.convertToUserTime(x.start, center) : moment(x.start));
			const sessionEnd = (enableUserTimeZone ? utils.convertToUserTime(x.end, center) : moment(x.end));

			x.date = moment(sessionStart).startOf('day');
			x.description = `${sessionStart.format('LT')} - ${sessionEnd.format('LT')}`;
			switch (x.type) {
				case 'FullDay':
					x.order = 1;
					break;
				case 'Morning':
					x.order = 2;
					break;
				case 'Afternoon':
					x.order = 3;

					break;
			}

			switch (x.availability) {
				case 'Yes':
					x.className = 'green';
					break;
				case 'No':
					x.className = 'red';
					break;
				case 'Limited':
				case 'LastSpot':
					x.className = 'orange';
					break;
			}
		});

		const sessionsByDate = utils.groupBy(sessions, 'date');

		return <Row>{Object.keys(sessionsByDate).map(date => {
			const sessions = sessionsByDate[date];
			return <Col xs={6} sm={4} md={2} key={date} style={{ paddingRight: 0 }}>
				<Panel className='date-container'>
					<Panel.Heading>{moment(date).format('ddd, l')}</Panel.Heading>
					<ListGroup>
						{sessions.sort((a, b) => a.order - b.order).map(s => {
							const disabled = s.availability === 'No' || (!s.upcoming && !currentUser.userImpersonation);
							return <ListGroupItem key={s.id} className={s.className}>
								<Checkbox checkboxClass='icheckbox_minimal-grey bg' increaseArea='20%' disabled={disabled}
									label={<span className={disabled ? 'text-muted' : ''}>{s.description}{(s.availableSpots <= limitToShowLeftWorkshopSpots && s.availableSpots > 0) && <Label bsStyle='danger' style={{ marginLeft: 5 }}>{t('FO_Booking_Availability_RemainingSpots', { count: s.availableSpots })}</Label>}</span>}
									checked={this.state.selectedWorkshopSessions.some(x => x.id === s.id)}
									onChange={(e, checked) => this.handleChangeSelection([s], checked)}
								/>
							</ListGroupItem>;
						})}
					</ListGroup>
				</Panel>
			</Col>;
		})}
		</Row>;
	}

	render() {
		const {
			workshop,
			bookingOptions: { errorMessage }, t
		} = this.props;

		return <div>
			{workshop && <div className='steps_title'>{t('FO_Booking_WorkshopSessions_Title', { workshopName: workshop.name })}</div>}
			{errorMessage && <Alert bsStyle='danger'>
				<div>{errorMessage}</div>
			</Alert>}
			<div className='booking-options-container' style={{ width: '100%', margin: 0 }}>
				<div className='availability-legend hidden-xs pull-right' style={{ marginTop: 15 }}>
					<span className='green' />{t('FO_Booking_Availability_Yes')}
					<span className='orange' />{t('FO_Booking_Availability_Limited')}
					<span className='red' />{t('FO_Booking_Availability_No')}
				</div>
				<ReduxBlockUi block={this.props.block} unblock={this.props.unblock}>
					{workshop && workshop.weeks.sort((a, b) => moment(a.startDate) - moment(b.startDate)).map(week => this.renderWeek(week))}
					<div style={{ paddingTop: '10px' }}>
						<Button className='btn btn-primary pull-right' disabled={this.state.selectedWorkshopSessions.length === 0} onClick={this.handleConfirmSelection}>{t('FO_Booking_Workshop_ConfirmSessions')} <i className='fa fa-arrow-circle-right' /></Button>
						<Button className='btn btn-back btn-block-xxs' onClick={this.props.onNavigateBack}><FontAwesome name='arrow-circle-left' /> {t('FO_Booking_WorkshopSessions_Back')}</Button>
					</div>
					<div className='clearfix' />
				</ReduxBlockUi>
			</div>
		</div>;
	}
}

WorkshopSessions.propTypes = {
};

export default withNamespaces()(WorkshopSessions);